import { appConfig } from "@/config/env";

const TENANT_KEY = "amos_tenant_id";
const INDUSTRY_KEY = "amos_industry_id";

export function getAccessToken(): string | null {
  return localStorage.getItem(appConfig.tokenStorageKey);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(appConfig.refreshTokenStorageKey);
}

export function setTokens(accessToken: string, refreshToken?: string): void {
  localStorage.setItem(appConfig.tokenStorageKey, accessToken);
  if (refreshToken) {
    localStorage.setItem(appConfig.refreshTokenStorageKey, refreshToken);
  }
}

export function clearTokens(): void {
  localStorage.removeItem(appConfig.tokenStorageKey);
  localStorage.removeItem(appConfig.refreshTokenStorageKey);
  localStorage.removeItem(TENANT_KEY);
  localStorage.removeItem(INDUSTRY_KEY);
}

export function getTenantId(): string | null {
  return localStorage.getItem(TENANT_KEY);
}

export function setTenantId(tenantId: string): void {
  if (tenantId) localStorage.setItem(TENANT_KEY, tenantId);
}

export function getIndustryId(): string | null {
  return localStorage.getItem(INDUSTRY_KEY);
}

export function setIndustryId(industryId: string): void {
  if (industryId) localStorage.setItem(INDUSTRY_KEY, industryId);
}
